import React, { useState } from 'react'
import Cookies from 'js-cookie'

import SchoolSelectionList from './v3/SchoolSelectionList'
import BubbleMessageStack from './v3/BubbleMessageStack'
import CopyResultsMessage from './v3/CopyResultsMessage'

const copyFormToSchools = (formId, selectedSchoolIds, callback) => {
  const csrftoken = Cookies.get('csrftoken')
  fetch(`/api/v1/forms/${formId}/copy`,
    {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'X-CSRFToken': csrftoken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ schools: selectedSchoolIds }),
    })
    .then((response) => response.json().then((obj) => ({ ok: response.ok, obj })))
    .then(({ ok, obj }) => {
      if (!ok || obj.error) {
        alert(I18N._("Failed to copy questionnaire") + ": " + (obj.error || JSON.stringify(obj)))
      } else {
        callback({ success: obj.success, fail: obj.fail })
      }
    })
    .catch((err) => {
      console.error(err)
      alert(I18N._("Error requesting data from backend") + ": " + err)
    })
}

const toggleFormSharing = (schoolId, formId, callback) => {
  const csrftoken = Cookies.get('csrftoken')
  fetch(`/api/v1/forms/${schoolId}/${formId}/toggle-sharing`,
    {
      method: 'PATCH',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'X-CSRFToken': csrftoken,
      },
    })
    .then(response => response.json())
    .then(obj => {
      if (obj.error) {
        alert(I18N._("Failed to update questionnaire sharing") + ": " + JSON.stringify(obj))
      } else {
        callback(obj.share_token)
      }
    })
    .catch(err => {
      console.error(err)
      alert(I18N._("Error requesting data from backend") + ": " + err)
    })
}

export default ({ formId, schoolId, initialShareToken = null }) => {
  const [shareToken, setShareToken] = useState(initialShareToken)
  const [copyResults, setCopyResults] = useState(null)

  const sharingLink = shareToken ? `${window.location.origin}/review-shared-form/${shareToken}` : null

  const addQuestionnaireToSchools = (selectedSchoolIds) => {
    copyFormToSchools(formId, selectedSchoolIds, setCopyResults)
  }

  const toggleSharingLink = (ev) => {
    ev.preventDefault()
    toggleFormSharing(schoolId, formId, setShareToken)
  }

  return (
    <React.Fragment>
      <BubbleMessageStack>
        <CopyResultsMessage results={copyResults} />
      </BubbleMessageStack>

      <div className="add-to-school form-group row even vertical-padding">
        <div className="col-sm-4 col-xs-12">
          <label className="control-label">
            {I18N._("Add questionnaire to another school")}
          </label>
          <p className="help-block">
            {I18N._("Add this questionnaire directly to other schools you control. The schools will receive the same questions and the results can be compared.")}
          </p>
        </div>
        <div className="col-sm-8 col-xs-12">
          <SchoolSelectionList
            submitLabel={I18N._("Add questionnaire to schools")}
            onSubmit={addQuestionnaireToSchools}
          />
        </div>
      </div>

      <div className="form-group row odd vertical-padding">
        <div className="col-sm-4 col-xs-12">
          <label className="control-label">
            {I18N._("Create a questionnaire sharing link")}
          </label>
          <p className="help-block">
            {I18N._("Create a link you can distributre to other school admins to add the questionnaire to their School Wellbeing Profile")}
          </p>
        </div>
        <div className="col-sm-8 col-xs-12">
          <div className="form-group">
            <input
              readOnly
              type="text"
              className="form-control"
              value={sharingLink || I18N._("Not currently shared")}
            />
          </div>
          <div className="button-group pull-right">
            <button className="btn btn-success" onClick={toggleSharingLink}>
              {sharingLink ? I18N._("Disable sharing") : I18N._("Create a sharing link")}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
